<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-0 px-4 layout row wrap">
          <v-btn class="primary ma-0" @click='$router.push({ name: "languageMappingCreate" })'>{{$lang.actions.createLangMapp}}</v-btn>
          <v-checkbox
            color="primary"
            class="ml-3 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-text-field
            class="min-w max-w"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="showActive ? activePrinterCategories : allPrinterCategories"
          :search="search"
          :loading="allPrinterCategories.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.companyName }}</td>
            <td>{{ formatDate(props.item.createdOn) }}</td>
            <td>{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'languageMappingEdit', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        headers: [
          {text: this.$lang.labels.company, value: 'companyName', align: 'left',},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        showActive: true,
        allPrinterCategories: [],
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      changeStatus(printerCategory) {
        const action = printerCategory.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`printercategory/${action}/${printerCategory.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(printerCategory, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      activePrinterCategories() {
        const printerCategories = this.allPrinterCategories;
        const activePrinterCategories = [];
        for (let i=0; printerCategories.length > i; i++) {
          if (printerCategories[i].status === 'active') {
            activePrinterCategories.push(printerCategories[i]);
          }
        }
        return activePrinterCategories;
      },
    },
    created() {
      this.$http.get('printercategory/getall')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allPrinterCategories = res.body.details;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    }
  };
</script>



// WEBPACK FOOTER //
// LanguageMappings.vue?36bdfb98